// NOTE: dependencies.tsx の中においておくと、next/dynamic が内包されている関係で、一緒にテストできないのでファイル分割する
import { Post_post$data } from '@/components/Post/__generated__/Post_post.graphql'

// NOTE: パフォーマンス的によろしくなければ、getStaticProps の中で直接本文を置換する(fragmentは使えなくなるが。。。)
export const replacePostBody = (
  body: string,
  shortcodes: Post_post$data['shortcodes'],
  template: Post_post$data['template_name']
): string => {
  // shortcode を 置換
  const replaced = body.replace(
    /<%= shortcode\((\d+)\) %>/g,
    (...[, index]) => {
      const shortcode = shortcodes.find((sc) => String(sc.index) === index)
      if (!shortcode) return ''
      return `<div class="shortcode-element" data-shortcode-category="${
        shortcode.category
      }" data-shortcode-code="${
        shortcode.code
      }" data-shortcode-params="${escape(
        JSON.stringify(shortcode.params)
      )}" style="display: none"></div>`
    }
  )

  if (template !== 'show_post') return replaced

  // h2 を抽出して toc 生成
  const h2s = replaced.match(/<h2(.*?)id="(.+?)"(.*?)>(.+?)<\/h2>/g)
  if (!h2s) return replaced

  const tocData = h2s.map((h2) => {
    const [, , id, , title] =
      h2.match(/<h2(.*?)id="(.+?)"(.*?)>(.+?)<\/h2>/) ?? []
    return { id, title: title?.replace(/<(.+?)>/g ?? '', '') }
  })
  const insertIndex = replaced.indexOf('<h2')
  return (
    replaced.slice(0, insertIndex) +
    `<div class="toc-element" data-toc="${escape(
      JSON.stringify(tocData)
    )}"></div>` +
    replaced.slice(insertIndex)
  )
}

const escape = (html: string) =>
  html.replace(/[&'`"<>]/g, (match) => mappings[match] ?? '')

const mappings: Record<string, string> = {
  '&': '&amp;',
  "'": '&#x27;',
  '`': '&#x60;',
  '"': '&quot;',
  '<': '&lt;',
  '>': '&gt;'
}
